module.exports = __webpack_public_path__ + "img/DSC_0180 teatro ilpa 2_thumb.132e3e5f.jpg";